module.exports = __webpack_public_path__ + "img/icons8-wicker-basket-96.25b69414.png";